import type { Role } from '@cusp/core';

/**
 * The design's words for a role, wherever the learner app shows one to a
 * person: under a workspace name in the account menu, beside a membership in
 * the sign-in picker. The database's `institution_admin` never reaches a
 * reader. `Record<Role, …>` so a role added to `@cusp/core` without a word
 * here is a typecheck failure, not a raw enum value on screen.
 */
export const ROLE_LABELS: Record<Role, string> = {
  learner: 'Learner',
  faculty: 'Faculty',
  institution_admin: 'Administrator',
  cusp_admin: 'Cusp admin',
};
